var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoKorean = function SvgLogoKorean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M35.568 8.313c1.907 0 3.514-1.418 3.882-3.299h1.171v3.3h1.774V0h-1.774v3.299h-1.17c-.403-1.88-1.976-3.266-3.883-3.266s-3.48 1.386-3.882 3.266h-2.577V0h-1.774v8.313h1.774V5.014h2.577c.368 1.88 1.974 3.3 3.882 3.3m0-6.63c1.305 0 2.376 1.121 2.376 2.507 0 1.385-1.07 2.507-2.376 2.507s-2.376-1.122-2.376-2.507 1.07-2.508 2.376-2.508",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M60.133 8.313V6.565H49.96v-1.55h10.174V3.265H49.96v-1.55h10.174V0H48.185v8.313z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.89 9.633h12.685V16H32.89zm1.774 4.685h9.137v-3.002h-9.137zM1.866 9.633V16h11.847V9.633zm10.04 4.685h-8.3v-3.002h8.3z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.945 1.781 2.468 7.984H.561L3.707.099H7.32l3.146 7.885H8.559L6.083 1.78zM17.997 7.984l2.477-6.203h1.138l2.476 6.203h1.908L22.85.099h-3.614l-1.272 3.2h-4.351V0h-1.774v8.313h1.774V5.014h3.648L16.09 7.951h1.907z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.361 9.633H29.21V16H17.361zm1.774 4.685h8.3v-3.002h-8.3z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.541 8.313V0h-1.773v8.313zM61.439 9.633v1.683h-6.393V16h-1.774v-4.684h-6.425V9.633z"
  })));
};
export default SvgLogoKorean;